import React, { useState, useEffect } from 'react';
import './SuppliesStock.css';

function SuppliesStock() {
  const [suppliesData, setSuppliesData] = useState([]);
  const [newItemName, setNewItemName] = useState('');
  const [editingHomeStock, setEditingHomeStock] = useState(null);
  const [editingTransitStock, setEditingTransitStock] = useState(null);
  const [tempHomeStock, setTempHomeStock] = useState('');
  const [tempTransitStock, setTempTransitStock] = useState('');
  const [tempTransitDate, setTempTransitDate] = useState('');
  const [tempSupplierId, setTempSupplierId] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  // Charger les données depuis l'API au démarrage
  useEffect(() => {
    loadSuppliesData();
  }, []);

  // Charger les données depuis l'API
  const loadSuppliesData = async () => {
    try {
      const response = await fetch('/api/supplies');
      if (response.ok) {
        const supplies = await response.json();
        // Mapper les données de l'API vers le format du composant
        const mappedData = supplies.map(supply => ({
          id: supply.id,
          name: supply.name,
          homeQuantity: supply.home_quantity,
          transitQuantity: supply.transit_quantity,
          transitOrderDate: supply.transit_order_date,
          transitSupplierId: supply.transit_supplier_id
        }));
        setSuppliesData(mappedData);
      }
    } catch (error) {
      console.error('Erreur lors du chargement du stock fournitures :', error);
    }
  };


  // Ajouter un nouvel article
  const addNewItem = async () => {
    if (newItemName.trim() === '') return;
    
    try {
      const response = await fetch('/api/supplies', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: newItemName.trim(),
          home_quantity: 0,
          transit_quantity: 0,
          transit_order_date: null,
          transit_supplier_id: null
        }),
      });

      if (response.ok) {
        // Recharger les données depuis l'API
        await loadSuppliesData();
        setNewItemName('');
      } else {
        console.error('Erreur lors de l\'ajout de l\'article');
        alert('Erreur lors de l\'ajout de l\'article');
      }
    } catch (error) {
      console.error('Erreur lors de l\'ajout de l\'article :', error);
      alert('Erreur lors de l\'ajout de l\'article');
    }
  };

  // Supprimer un article
  const removeItem = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cet article ?')) {
      try {
        const response = await fetch(`/api/supplies/${id}`, {
          method: 'DELETE',
        });

        if (response.ok) {
          // Recharger les données depuis l'API
          await loadSuppliesData();
        } else {
          console.error('Erreur lors de la suppression de l\'article');
          alert('Erreur lors de la suppression de l\'article');
        }
      } catch (error) {
        console.error('Erreur lors de la suppression de l\'article :', error);
        alert('Erreur lors de la suppression de l\'article');
      }
    }
  };

  // Gestion de l'édition du stock à la maison
  const handleHomeStockEdit = (id) => {
    const item = suppliesData.find(item => item.id === id);
    setEditingHomeStock(id);
    setTempHomeStock(item.homeQuantity || 0);
  };

  const handleHomeStockSave = async (id) => {
    const item = suppliesData.find(item => item.id === id);
    if (!item) return;

    try {
      const response = await fetch(`/api/supplies/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: item.name,
          home_quantity: parseInt(tempHomeStock) || 0,
          transit_quantity: item.transitQuantity,
          transit_order_date: item.transitOrderDate,
          transit_supplier_id: item.transitSupplierId
        }),
      });

      if (response.ok) {
        await loadSuppliesData();
        setEditingHomeStock(null);
      } else {
        console.error('Erreur lors de la mise à jour du stock');
        alert('Erreur lors de la mise à jour du stock');
      }
    } catch (error) {
      console.error('Erreur lors de la mise à jour du stock :', error);
      alert('Erreur lors de la mise à jour du stock');
    }
  };

  // Gestion de l'édition du stock en transit
  const handleTransitStockEdit = (id) => {
    const item = suppliesData.find(item => item.id === id);
    
    let orderDate = new Date();
    if (item.transitOrderDate) {
      orderDate = new Date(item.transitOrderDate);
    }
    
    setEditingTransitStock(id);
    setTempTransitStock(item.transitQuantity || 0);
    setTempTransitDate(orderDate.toISOString().split('T')[0]);
    setTempSupplierId(item.transitSupplierId || '');
  };

  const handleTransitStockSave = async (id) => {
    const item = suppliesData.find(item => item.id === id);
    if (!item) return;

    try {
      const response = await fetch(`/api/supplies/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: item.name,
          home_quantity: item.homeQuantity,
          transit_quantity: parseInt(tempTransitStock) || 0,
          transit_order_date: tempTransitDate || null,
          transit_supplier_id: tempSupplierId || null
        }),
      });

      if (response.ok) {
        await loadSuppliesData();
        setEditingTransitStock(null);
      } else {
        console.error('Erreur lors de la mise à jour du stock en transit');
        alert('Erreur lors de la mise à jour du stock en transit');
      }
    } catch (error) {
      console.error('Erreur lors de la mise à jour du stock en transit :', error);
      alert('Erreur lors de la mise à jour du stock en transit');
    }
  };

  // Transférer le stock en transit vers le stock maison
  const transferTransitToHome = async (id) => {
    const item = suppliesData.find(item => item.id === id);
    if (!item || item.transitQuantity <= 0) return;

    try {
      const response = await fetch(`/api/supplies/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: item.name,
          home_quantity: (item.homeQuantity || 0) + (item.transitQuantity || 0),
          transit_quantity: 0,
          transit_order_date: null,
          transit_supplier_id: null
        }),
      });

      if (response.ok) {
        await loadSuppliesData();
        alert('Stock transféré avec succès vers le stock à la maison');
      } else {
        console.error('Erreur lors du transfert de stock');
        alert('Erreur lors du transfert de stock');
      }
    } catch (error) {
      console.error('Erreur lors du transfert de stock :', error);
      alert('Erreur lors du transfert de stock');
    }
  };

  // Filtrer les données selon le terme de recherche
  const filteredData = suppliesData.filter(item => {
    const term = searchTerm.toLowerCase();
    return item.name.toLowerCase().includes(term);
  });

  return (
    <div className="supplies-stock-container">
      <h2>Stock Fournitures</h2>
      
      {/* Section d'ajout d'un nouvel article */}
      <div className="add-item-section">
        <div className="add-item-form">
          <input
            type="text"
            placeholder="Nom de la fourniture (ex: enveloppes, étiquettes...)"
            value={newItemName}
            onChange={(e) => setNewItemName(e.target.value)}
            className="item-name-input"
            onKeyPress={(e) => e.key === 'Enter' && addNewItem()}
          />
          <button onClick={addNewItem} className="add-item-btn">
            Ajouter
          </button>
        </div>
      </div>

      {/* Barre de recherche */}
      <div className="table-controls">
        <input
          type="text"
          placeholder="Rechercher une fourniture..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
      
      {/* Tableau des fournitures */}
      <div className="table-wrapper">
        <table className="supplies-table">
          <thead>
            <tr>
              <th>Fourniture</th>
              <th>Stock Maison</th>
              <th>Stock en Transit</th>
              <th>Stock Total</th>
              <th>Date de commande</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item) => {
              const totalStock = (item.homeQuantity || 0) + (item.transitQuantity || 0);
              
              return (
                <tr key={item.id} className="supply-row">
                  <td>{item.name}</td>
                  
                  {/* Stock Maison éditable */}
                  <td className="editable-cell">
                    {editingHomeStock === item.id ? (
                      <div className="edit-mode">
                        <input
                          type="number"
                          value={tempHomeStock}
                          onChange={(e) => setTempHomeStock(e.target.value)}
                          min="0"
                          className="stock-input"
                        />
                        <button 
                          onClick={() => handleHomeStockSave(item.id)}
                          className="save-btn"
                        >
                          ✓
                        </button>
                      </div>
                    ) : (
                      <div className="display-mode">
                        <span>{item.homeQuantity || 0}</span>
                        <button 
                          onClick={() => handleHomeStockEdit(item.id)}
                          className="edit-btn"
                        >
                          ✎
                        </button>
                      </div>
                    )}
                  </td>
                  
                  {/* Stock en Transit éditable */}
                  <td className="editable-cell">
                    <div className="display-mode">
                      <span>{item.transitQuantity || 0}</span>
                      <div className="action-buttons">
                        <button 
                          onClick={() => handleTransitStockEdit(item.id)}
                          className="edit-btn"
                          title="Modifier la commande"
                        >
                          ✎
                        </button>
                        {item.transitQuantity > 0 && (
                          <button 
                            onClick={() => transferTransitToHome(item.id)}
                            className="delivered-btn"
                            title="Marquer comme livré"
                          >
                            ✓
                          </button>
                        )}
                      </div>
                    </div>
                  </td>
                  
                  {/* Stock Total */}
                  <td className="total-stock">{totalStock}</td>
                  
                  {/* Date de commande */}
                  <td>
                    {item.transitOrderDate ? new Date(item.transitOrderDate).toLocaleDateString() : '-'}
                  </td>
                  
                  {/* Actions */}
                  <td>
                    <button 
                      onClick={() => removeItem(item.id)}
                      className="remove-btn"
                      title="Supprimer cet article"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Résumé */}
      <div className="supplies-summary">
        <p>Total: {filteredData.length} fourniture(s)</p>
        <p>Stock Maison Total: {filteredData.reduce((sum, item) => sum + (item.homeQuantity || 0), 0)} unités</p>
        <p>Stock en Transit Total: {filteredData.reduce((sum, item) => sum + (item.transitQuantity || 0), 0)} unités</p>
        <p>Stock Global Total: {filteredData.reduce((sum, item) => sum + (item.homeQuantity || 0) + (item.transitQuantity || 0), 0)} unités</p>
      </div>
      
      {/* Popup d'édition du stock en transit */}
      {editingTransitStock && (
        <div className="supplier-select-overlay">
          <div className="supplier-select-popup">
            <h3>Détails de la commande en transit</h3>
            
            <div className="popup-field">
              <label>Quantité:</label>
              <input
                type="number"
                value={tempTransitStock}
                onChange={(e) => setTempTransitStock(e.target.value)}
                min="0"
                className="popup-input"
              />
            </div>
            
            <div className="popup-field">
              <label>Date de commande:</label>
              <input
                type="date"
                value={tempTransitDate}
                onChange={(e) => setTempTransitDate(e.target.value)}
                className="popup-input date-input"
              />
            </div>
            
            <div className="popup-field">
              <label>Fournisseur (optionnel):</label>
              <input
                type="text"
                value={tempSupplierId}
                onChange={(e) => setTempSupplierId(e.target.value)}
                placeholder="Nom du fournisseur"
                className="popup-input"
              />
            </div>
            
            <div className="supplier-select-buttons">
              <button onClick={() => setEditingTransitStock(null)} className="cancel-btn">
                Annuler
              </button>
              <button 
                onClick={() => handleTransitStockSave(editingTransitStock)}
                className="save-btn"
              >
                Enregistrer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SuppliesStock;